import { DatePicker } from "@/components/ui/date-picker";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

interface DateTimePickerProps {
  value: string | undefined;
  onDateChange: (value: string | undefined) => void;
  disabled?: boolean;
  blockDate?: (date: Date) => boolean;
  className?: string;
  dateFormat?: string;
  id?: string;
}

function parseDate(value: string | undefined): Date | undefined {
  if (!value) return undefined;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? undefined : date;
}

export function DateTimePicker({
  value,
  onDateChange,
  disabled,
  blockDate,
  className,
  dateFormat,
  id,
}: DateTimePickerProps) {
  const date = parseDate(value);

  const emit = (next: Date) => onDateChange(next.toISOString());

  return (
    <div className={cn("flex flex-col gap-2 sm:flex-row", className)}>
      <DatePicker
        date={date}
        onChange={(next) => {
          if (!next) {
            onDateChange(undefined);
            return;
          }
          const current = date ?? new Date();
          next.setHours(current.getHours(), current.getMinutes(), 0, 0);
          emit(next);
        }}
        disablePicker={disabled}
        disabled={blockDate}
        className="flex-1"
        dateFormat={dateFormat}
      />
      <Input
        id={id}
        type="time"
        className="sm:w-36"
        value={
          date
            ? `${date.getHours().toString().padStart(2, "0")}:${date
                .getMinutes()
                .toString()
                .padStart(2, "0")}`
            : ""
        }
        disabled={disabled || !date}
        onChange={(event) => {
          const [hours, minutes] = event.target.value.split(":").map(Number);
          if (!Number.isFinite(hours) || !Number.isFinite(minutes)) return;
          const next = date ? new Date(date) : new Date();
          next.setHours(hours, minutes, 0, 0);
          emit(next);
        }}
      />
    </div>
  );
}
